module.exports = __webpack_public_path__ + "media/bier.a61f3b73.mp4";